import { render } from "./IconReorder.vue?vue&type=template&id=5b99f39c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconReorder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b99f39c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b99f39c', __exports__)) {
    api.reload('5b99f39c', __exports__)
  }
  
  module.hot.accept("./IconReorder.vue?vue&type=template&id=5b99f39c", () => {
    api.rerender('5b99f39c', render)
  })

}


export default __exports__